module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "Section-head"
  }, [_vm._v("AMELIA EARHART")]), _vm._v(" "), _c('p', {
    staticClass: "Project_project-intro"
  }, [_vm._v("Why Amelia? Because she was a passionate and fearless chaser of dreams, who never gave up, in spite of the enormous challenges she faced in achieving her dreams. She wanted to fly and she flew. She wanted to cross the Atlantic Ocean with her plane, and she did. She dared to go where no other woman had gone before and encouraged others to follow her example of bravery. She was confident in the true power of women, knowing they could also excel in their chosen professions. And even though she died in the pursuit of her greatest feat, she still remains a guiding light for all like-minded dreamers.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P17.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "Project_YWN-head"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("2.5mm (C/2) crochet hook")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("100% 8-ply cotton; colours used: skin colour, white, beige, light brown, dark brown, mustard, small amount of pink")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("Yarn needle")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("8mm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v("in) safety eyes")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("Stitch marker")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("Fibrefill stuffing")]), _vm._v(" "), _c('h2', {
    staticClass: "Project_YWN-head"
  }, [_vm._v("FINISHED SIZE")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_vm._v("20cm (7"), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in) tall")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("LEG 1")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 1:")]), _vm._v(" Using "), _c('b', [_vm._v("light brown")]), _vm._v(" for the boots, 6 sc in a magic ring. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 2:")]), _vm._v(" 2 sc in each st. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 3 to 6:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 7:")]), _vm._v(" Change to "), _c('b', [_vm._v("beige")]), _vm._v(" for the pants, 1 sc BLO in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 8 and 9:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off. Set aside.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("LEG 2")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Work as for Leg 1, but do not fasten off yarn at the end. We will continue with the body.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("BODY")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 10:")]), _vm._v(" Still with leg 2 on your hook, ch 3 and join to leg 1 with a sc "), _c('i', [_vm._v("(see "), _c('span', {
    attrs: {
      "href": "#/Techniques#JL",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques: Joining Legs")]), _vm._v(")")]), _vm._v(", place a stitch marker here for new beg of round, work 11 sc all along leg 1, 1 sc into each ch of 3-ch-loop, 12 sc all along leg 2 and 1 sc into other side of each ch of 3-ch-loop. (30 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 11:")]), _vm._v(" *4 sc, 2 sc in the next st, rep from * to end. (36 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 12 to 15:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 16:")]), _vm._v(" Change to "), _c('b', [_vm._v("light brown")]), _vm._v(" for the belt, 1 sc BLO in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 17:")]), _vm._v(" *4 sc, sc2tog, rep from * to end. (30 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 18:")]), _vm._v(" Change to "), _c('b', [_vm._v("white")]), _vm._v(" for the shirt, 1 sc BLO in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 19 and 20:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Stuff the legs firmly at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 21:")]), _vm._v(" *3 sc, sc2tog, rep from * to end. (24 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 22 and 23:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 24:")]), _vm._v(" *2 sc, sc2tog, rep from * to end. (18 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Stuff the body firmly at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 25 and 26:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 27:")]), _vm._v(" *1 sc, sc2tog, rep from * to end. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 28:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 29:")]), _vm._v(" 7 sc, change to "), _c('b', [_vm._v("skin")]), _vm._v(" colour, 1 sc, change back to "), _c('b', [_vm._v("white")]), _vm._v(", 4 sc.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 30:")]), _vm._v(" 6 sc, change to "), _c('b', [_vm._v("skin")]), _vm._v(" colour, 3 sc, change back to "), _c('b', [_vm._v("white")]), _vm._v(", 3 sc.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 31:")]), _vm._v(" 5 sc, change to "), _c('b', [_vm._v("skin")]), _vm._v(" colour, 5 sc, change back to "), _c('b', [_vm._v("white")]), _vm._v(", 2 sc.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("You should have a "), _c('b', [_vm._v("skin")]), _vm._v(" colour triangle at the front centre of the doll.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Do not fasten off yarn. We will continue with the head.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("HEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 32:")]), _vm._v(" Change to "), _c('b', [_vm._v("skin")]), _vm._v(" colour, 2 sc BLO in each of the first 5 sts (those in "), _c('b', [_vm._v("white")]), _vm._v("), 2 sc through both loops in each of the following 5 sts (those in "), _c('b', [_vm._v("skin")]), _vm._v(" colour), 2 sc BLO in each of last 2 sts (those in "), _c('b', [_vm._v("white")]), _vm._v("). (24 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 33:")]), _vm._v(" *3 sc, 2 sc in the next st, rep from * to end. (30 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Stuff the neck area firmly at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 34:")]), _vm._v(" *4 sc, 2 sc in the next st, rep from * to end. (36 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 35:")]), _vm._v(" *5 sc, 2 sc in the next st, rep from * to end. (42 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 36:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 37:")]), _vm._v(" 27 sc, 1 bobble st for the nose "), _c('i', [_vm._v("(see "), _c('a', {
    attrs: {
      "href": "#/Stitches#bb"
    }
  }, [_vm._v("Stitches: Bobble st")]), _vm._v(")")]), _vm._v(", 1 sc in each st to end.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Be sure to align the nose with the middle of the legs, and the "), _c('b', [_vm._v("skin")]), _vm._v(" colour triangle at the neck, and adjust the positioning if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("We will take a break here from the head to work the collar of Amelia’s shirt. Place a stitch marker in the loop on your hook to secure.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("For detailed photographs of how to work a collar see "), _c('span', {
    attrs: {
      "href": "#/Techniques#VC",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Techniques: Creating the V Collar")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Project_step"
  }, [_vm._v("Join the "), _c('b', [_vm._v("white")]), _vm._v(" yarn 2 rounds below the tip of the "), _c('b', [_vm._v("skin")]), _vm._v(" triangle.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_step"
  }, [_vm._v("Work in the spaces between stitches and crochet 2 surface sc up until you reach the bottom tip of the triangle.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_step"
  }, [_vm._v("Now follow the diagonal of the triangle, working the right side first. Crochet 1 surface sc in between each round, inserting the hook in the spaces between rounds, until you reach the round where the white front loops are showing.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_step"
  }, [_vm._v("Now crochet 2 sc in each front loop of the shirt bordering Amelia’s neck, until you reach the edge of the triangle on the other side. (14 sts). Work 5 surface sc in between rounds following the diagonal of the triangle to the starting stitch, work 1 slst in the starting stitch. Fasten off and weave in ends.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("We will now continue with the head. Rejoin the "), _c('b', [_vm._v("skin")]), _vm._v(" colour yarn to where you stopped working the head.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 38 to 46:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 47:")]), _vm._v(" *5 sc, sc2tog, rep from * to end. (36 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Start stuffing the head at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 48:")]), _vm._v(" *4 sc, sc2tog, rep from * to end. (30 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Place safety eyes one round above the nose, with 8 sts between them, embroider cheeks with "), _c('b', [_vm._v("pink")]), _vm._v(" yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 49:")]), _vm._v(" *3 sc, sc2tog, rep from * to end. (24 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 50:")]), _vm._v(" *2 sc, sc2tog, rep from * to end. (18 sts) Stuff firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 51:")]), _vm._v(" *1 sc, sc2tog, rep from * to end. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 52:")]), _vm._v(" (sc2tog) 6 times. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off and weave in ends.")]), _vm._v(" "), _c('div', {
    staticClass: "gray-box"
  }, [_c('h2', {
    staticClass: "Tip-head"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "Tip-b"
  }, [_vm._v("If you don’t want to do Amelia’s collar with surface single crochet, just embroider two diagonal lines using the colour of her shirt, to mark the edges of the skin triangle showing on her neck.")])]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("ARMS (MAKE TWO)")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 1:")]), _vm._v(" Using "), _c('b', [_vm._v("skin")]), _vm._v(" colour, ch 2, 4 sc in the second ch from hook. (4 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 2:")]), _vm._v(" 2 sc in each st. (8 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 3 to 5:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 6:")]), _vm._v(" Change to "), _c('b', [_vm._v("mustard")]), _vm._v(" yarn for the jacket, 1 sc BLO in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 7 to 17:")]), _vm._v(" 1 sc in each st. There is no need to stuff the arms.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 18:")]), _vm._v(" Press the opening with your fingers, aligning 4 sts side by side and sc both sides together by working 1 sc into each pair of sts "), _c('i', [_vm._v("(see "), _c('span', {
    attrs: {
      "href": "#/Techniques#CL",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques: Closing the Arms")]), _vm._v(")")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off, leaving a long tail to sew to the body.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Project_project-quote"
  }, [_vm._v("“Please know I am quite aware of the hazards. I want to do it because I want to do it. Women must try to do things as men have tried. When they fail, their failure must be but a challenge to others.”")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P19.jpg"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("JACKET")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("The jacket is actually a vest, but when you put it on your Amelia, together with the arms, it will look like a jacket. The vest is worked in rows, using "), _c('b', [_vm._v("mustard")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Ch 21, 1 sc in the second ch from hook, 1 sc in each ch to end, ch 1, turn. (20 sc)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" 4 sc, *ch 6, skip the following 4 sts (to create armhole), 4 sc, rep from * once more, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 3:")]), _vm._v(" 4 sc, *6 sc in the 6-ch-loop, 4 sc, rep from * once more, ch 1, turn. (24 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rows 4 to 14:")]), _vm._v(" 1 sc in each st, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 15:")]), _vm._v(" 1 sc in each st, ch 1, rotate the work 90 degrees clockwise and work 15 sc along the side of the vest, working in the spaces between rows. When you reach the top edge, crochet 20 slst in the remaining loops of the foundation chain. Then ch 1, rotate the piece 90 degrees clockwise again and work 15 sc along the other side of the vest, working in the spaces between rows "), _c('i', [_vm._v("(see "), _c('span', {
    attrs: {
      "href": "#/Techniques#FP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques: Edging of Flat Pieces")]), _vm._v(")")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off and weave in ends.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("AVIATOR HAT")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P20-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P20-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 1:")]), _vm._v(" Using "), _c('b', [_vm._v("light brown")]), _vm._v(" for the hat, 6 sc in a magic ring. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 2:")]), _vm._v(" 2 sc in each st. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 3:")]), _vm._v(" *1 sc, 2 sc in the next st, rep from * to end. (18 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 4:")]), _vm._v(" *2 sc, 2 sc in the next st, rep from * to end. (24 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 5:")]), _vm._v(" *3 sc, 2 sc in the next st, rep from * to end. (30 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 6:")]), _vm._v(" *4 sc, 2 sc in the next st, rep from * to end. (36 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 7:")]), _vm._v(" *5 sc, 2 sc in the next st, rep from * to end. (42 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 8:")]), _vm._v(" *13 sc, 2 sc in the next st, rep from * to end. (45 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rounds 9 to 15:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 16:")]), _vm._v(" 3 sc, 20 sc FLO, 22 sc.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("From now on we will be crocheting in rows, to make the first ear flap.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Rows 17 and 18:")]), _vm._v(" 8 sc, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 19:")]), _vm._v(" sc2tog, 4 sc, sc2tog, ch 1, turn. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 20:")]), _vm._v(" 1 sc in each st, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 21:")]), _vm._v(" sc2tog, 2 sc, sc2tog, ch 1, turn. (4 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 22:")]), _vm._v(" 1 sc in each st, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 23:")]), _vm._v(" (sc2tog) twice, ch 1, turn. (2 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 24:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off and weave in ends.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Count 20 sts around from the start of the first ear flap and join in the "), _c('b', [_vm._v("light brown")]), _vm._v(" yarn with a slip knot for the second ear flap.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" 8 sc, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" sc2tog, 4 sc, sc2tog, ch 1, turn. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 3:")]), _vm._v(" 1 sc in each st, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 4:")]), _vm._v(" sc2tog, 2 sc, sc2tog, ch 1, turn. (4 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 5:")]), _vm._v(" 1 sc in each st, ch 1, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 6:")]), _vm._v(" (sc2tog) twice, ch 1, turn. (2 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 7:")]), _vm._v(" 1 sc in each st.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Do not fasten off. Work one round of sc all around the edge of the hat and both ear flaps.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off and weave in ends.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("HAIR")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Using "), _c('b', [_vm._v("dark brown")]), _vm._v(" for the hair, attach with a slip knot in the first remaining back loop of round 16.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" 1 slst in first back loop, ch 11, 1 sc in the second ch from hook, 1 sc in each ch to end (10 sc), *1 slst in next back loop, ch 11, 1 sc in the second ch from hook, 1 sc in each ch to end (10 sc), rep from * to last st, 1 slst in last st. (19 hair curls)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off, and weave in ends.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("GOGGLES")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("First you will crochet the lenses and then you’ll join them to form the goggles.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("LENS 1")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 1:")]), _vm._v(" Using "), _c('b', [_vm._v("white")]), _vm._v(" for the lens, 6 sc in a magic ring. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 2:")]), _vm._v(" 2 sc in each st. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off, and weave in ends. Set aside.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("LENS 2")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 1:")]), _vm._v(" Using "), _c('b', [_vm._v("white")]), _vm._v(" for the lens, 6 sc in a magic ring. (6 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 2:")]), _vm._v(" 2 sc in each st. (12 sts)")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Round 3:")]), _vm._v(" Change to "), _c('b', [_vm._v("dark brown")]), _vm._v(" for the googles, and working through BLO for each st, *1 sc, 2 sc in the next st, rep from * to end. (18 sts). Still with lens 2 on your hook, ch 4 and join to lens 1 as follows: working through BLO, *1 sc, 2 sc in the next st, rep from * to end of lens 1 (18 sc), 1 sc in each ch of ch-4-loop, 1 slst in first st of the round to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off, and weave in ends.")]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("STRAP")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Using "), _c('b', [_vm._v("dark brown")]), _vm._v(", ch 51, 1 sc in the second ch from hook, 1sc in each ch to end. (50 sts).")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Fasten off, leaving a long tail to sew to goggles.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P21-2.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "Project_project-A"
  }, [_c('b', [_vm._v("ASSEMBLY")])]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Sew the aviator hat to Amelia’s head. Embroider some hair locks on her forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Sew the arms to the sides of the body "), _c('i', [_vm._v("(see "), _c('span', {
    attrs: {
      "href": "#/Techniques#SA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques: Sewing the Arms")]), _vm._v(")")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Place arms through vest armholes. Fix vest in place with a few stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Sew the goggles to the aviator hat, in line with Amelia’s eyes. Then surround the hat with the strap and sew it to the sides of the goggles.")]), _vm._v(" "), _c('p', {
    staticClass: "Project_pattern-body"
  }, [_vm._v("Weave in all ends inside the doll.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Project_project-quote"
  }, [_vm._v("“Never do things others can do and will do, if there are things others cannot do or will not do.”")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P21-3.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 84
// module chunks = 0